import React from 'react';

import ClaimsScreenContainer from '~/components/ClaimsScreen';

/**
 * CliveApp Claims List Screen Variant
 *
 * For now, this simply uses the standard ClaimsScreen component.
 * The CliveApp variant is focused on the individual claim detail page,
 * which shows only Notes and Documents tabs.
 *
 * The claims list remains the same as the standard implementation.
 */
export const CliveClaimsScreen: React.FC = () => {
  return <ClaimsScreenContainer />;
};
